export const searchFields = [
  {
    start: '调查开始时间',
    end: '调查结束时间',
    prop: 'investigateTime',
    type: 'date-picker',
    dateType: 'datetimerange',
    format: 'yyyy-MM-dd HH:mm',
    originvalue: '',
    value: [],
    hasMaxMinValue: true,
    span: 24
  }
]
export const searchFieldsPoint = [
  {
    label: '点位名称',
    prop: 'area',
    type: 'input',
    originvalue: '',
    value: '',
    span: 12
  },
  {
    start: '调查开始时间',
    end: '调查结束时间',
    prop: 'investigateTime',
    type: 'date-picker',
    dateType: 'datetimerange',
    format: 'yyyy-MM-dd HH:mm',
    originvalue: '',
    value: [],
    hasMaxMinValue: true,
    span: 12
  }
]

export const searchFieldsSub = [
  {
    label: '点位名称',
    prop: 'area',
    type: 'input',
    originvalue: '',
    value: '',
    span: 24
  }
]

export const commonAmount = [
  {
    width: 120,
    label: '单价(元)',
    value: 'minUnitPriceYuan',
    align: 'right',
    tooltip: 'false'
  },
  {
    width: 120,
    label: '到手金额(元)',
    align: 'right',
    value: 'expectedYuanAmount'
  }
  // {
  //   width: 110,
  //   label: '服务费(元)',
  //   value: 'serviceYuanAmount'
  // },
  // {
  //   width: 140,
  //   label: '预估花费(元)',
  //   value: 'operationalYuanAmount'
  // }
]
export const surveyTableColumnAnswer = [
  {
    width: 170,
    label: '答卷ID',
    value: 'originId'
  },
  {
    width: 150,
    label: '答题时间',
    value: 'investigateTime'
  },
  {
    width: 100,
    label: '审核员',
    value: 'assessorName'
  },
  {
    width: 120,
    label: '手机号码',
    value: 'assessorPhone'
  },
  {
    width: 150,
    label: '审核时间',
    value: 'assessTime'
  },
  ...commonAmount,
  {
    label: '操作',
    value: 'opt',
    width: 120,
    fixed: 'right'
  }
]

export const surveyTableColumnDay = [
  {
    width: 150,
    label: '调查日期',
    value: 'investigateDateStr'
  },
  {
    width: 150,
    label: '执行时间',
    value: 'investigateStartTime',
    headName: 'investigateStartTimeHeader',
    tipContent: '当天首次答题时间-最后一次答题时间'
  },
  {
    width: 90,
    label: '答卷数量',
    align: 'right',
    value: 'itemNum'
  },
  ...commonAmount,
  {
    label: '操作',
    value: 'opt',
    width: 120,
    fixed: 'right'
  }
]

export const surveyTableColumnStair = [...surveyTableColumnDay]

export const inquiryTableColumnPoint = [
  {
    width: 120,
    label: '点位',
    value: 'area'
  },
  {
    width: 150,
    label: '案件数',
    align: 'right',
    value: 'itemNum'
  },
  {
    width: 150,
    label: '调查时间',
    value: 'investigateEndTime'
  },
  ...commonAmount,
  {
    label: '操作',
    value: 'opt',
    width: 120,
    fixed: 'right'
  }
]

export const inquiryTableColumnStair = [
  {
    width: 120,
    label: '调查日期',
    value: 'investigateDateStr'
  },
  {
    width: 150,
    label: '执行时间',
    value: 'investigateStartTime',
    headName: 'investigateStartTimeHeader',
    tipContent: '当天首次答题时间-最后一次答题时间'
  },
  {
    width: 150,
    label: '案件数量',
    align: 'right',
    value: 'itemNum'
  },
  {
    width: 120,
    label: '关联点位',
    align: 'right',
    value: 'areaNum'
  },
  ...commonAmount,
  {
    label: '操作',
    value: 'opt',
    width: 120,
    fixed: 'right'
  }
]

export const inquiryTableColumnDay = [...inquiryTableColumnStair]

export const surveyTableColumnSub = [
  {
    width: 120,
    label: '答卷ID',
    value: 'originId'
  },
  {
    width: 150,
    label: '答题时间',
    value: 'investigateTime'
  },
  {
    label: '操作',
    value: 'opt',
    width: 120,
    fixed: 'right'
  }
]

export const inquiryTableColumnSub = [
  {
    width: 120,
    label: '案件ID',
    value: 'originId'
  },
  {
    width: 150,
    label: '点位',
    value: 'areaStr'
  },
  {
    label: '操作',
    value: 'opt',
    width: 120,
    fixed: 'right'
  }
]

export const inquiryTableColumnSubPoint = [
  {
    width: 120,
    label: '案件ID',
    value: 'originId'
  },
  {
    label: '操作',
    value: 'opt',
    width: 120,
    fixed: 'right'
  }
]
